













import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";

const COLORS = ["success", "danger", "cancel", "warning", "processing", "text"];

@Component({})
export default class GtCapsuleTag extends Vue {
  // 文本
  @Prop({ default: "", type: String }) text;

  // 类型
  @Prop({
    default: "processing",
    type: String,
    validator: (type: any) => COLORS.includes(type)
  })
  defaultType;

  // 是否为圆角
  @Prop({
    default: true,
    type: Boolean
  })
  round;

  /* options 对象
   *  status  当前状态
   *  color
   *      success 绿色 只有一个 String | 多个Array   必须
   *      danger  红色 只有一个 String | 多个Array   必须
   *      cancel
   *      warning
   *      processing
   *      text
   * */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  options;
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  color;
  @Prop({ default: "", type: [String, Number] }) status;

  // 起泡球的类型
  get type() {
    let { status: newStatus, color: newColor } = this.options;
    let { status, color } = this;

    if (this.options.status === undefined && this.options.color === undefined) {
      newStatus = status;
      newColor = [color];
    }

    let map: any = {};

    if (newColor instanceof Array && newColor.length > 0) {
      newColor.forEach(coloritem => {
        Object.entries(coloritem).forEach(v => {
          if (v[1] instanceof Array) {
            v[1].forEach(i => {
              return (map[i] = v[0]);
            });
          } else {
            let key: any = v[1];
            return (map[key] = v[0]);
          }
        });
      });
    }

    return map[newStatus] || this.defaultType;
  }
}
